import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './FeaturedStory.css';

const FeaturedStory = () => {
  const slides = [
    {
      id: 1,
      heroArticle: {
        image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=800&h=500&fit=crop',
        alt: 'Venezuela Presidential Palace',
        hasVideo: true,
        duration: '4:08',
        category: 'In Focus',
        title: 'Venezuela Regroups With New Leader, Old Repression Tactics',
        description: "Venezuela's government is reasserting itself after the capture of Nicolás Maduro.",
        relatedLink: "Venezuela's New Leader Is Who Global Oil Wanted All Along",
        articleUrl: '/article/venezuela-regroups-new-leader'
      },
      secondaryStories: [
        { title: 'Caracas Shaken by Gunfire Near Venezuela Presidential Palace', opinion: false, articleUrl: '/article/caracas-gunfire-presidential-palace' },
        { title: 'Trump Now Has His Very Own Oil Empire', opinion: true, author: 'Javier Blas', articleUrl: '/article/trump-oil-empire' },
        { title: 'Maduro Case Judge, 92, Brings History of Dealing With Trump', opinion: false, articleUrl: '/article/maduro-case-judge' }
      ]
    },
    {
      id: 2,
      heroArticle: {
        image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=500&fit=crop',
        alt: 'Stock Market Trading Floor',
        hasVideo: true,
        duration: '5:22',
        category: 'Markets',
        title: 'Global Markets Rally as Central Banks Signal Policy Shift',
        description: 'Stock markets surge worldwide as major central banks hint at potential interest rate adjustments amid economic uncertainty.',
        relatedLink: 'Fed Officials Debate Timing of Next Rate Decision',
        articleUrl: '/article/global-markets-rally'
      },
      secondaryStories: [
        { title: 'Wall Street Hits Record High on Tech Stock Momentum', opinion: false, articleUrl: '/article/wall-street-record-high' },
        { title: 'Why Investors Are Betting Big on AI Stocks in 2026', opinion: true, author: 'Sarah Chen', articleUrl: '/article/ai-stocks-2026' },
        { title: 'European Markets Follow Asian Lead With Strong Gains', opinion: false, articleUrl: '/article/european-markets-gains' }
      ]
    },
    {
      id: 3,
      heroArticle: {
        image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=500&fit=crop',
        alt: 'Climate Technology Innovation',
        hasVideo: true,
        duration: '6:15',
        category: 'Technology',
        title: 'Tech Giants Race to Deploy Carbon Capture Solutions',
        description: 'Major technology companies invest billions in carbon capture technologies as climate commitments intensify.',
        relatedLink: 'How AI is Revolutionizing Climate Change Solutions',
        articleUrl: '/article/tech-carbon-capture'
      },
      secondaryStories: [
        { title: 'Microsoft Announces Largest Carbon Removal Contract', opinion: false, articleUrl: '/article/microsoft-carbon-removal' },
        { title: 'The Real Cost of Big Tech\'s Climate Promises', opinion: true, author: 'David Martinez', articleUrl: '/article/tech-climate-promises' },
        { title: 'Startups Compete for Share of Carbon Credit Market', opinion: false, articleUrl: '/article/carbon-credit-startups' }
      ]
    },
    {
      id: 4,
      heroArticle: {
        image: 'https://images.unsplash.com/photo-1535320903710-d993d3d77d29?w=800&h=500&fit=crop',
        alt: 'Cryptocurrency Trading',
        hasVideo: true,
        duration: '3:45',
        category: 'Crypto',
        title: 'Bitcoin Breaks $100K Milestone Amid Institutional Adoption',
        description: 'Bitcoin reaches historic high as major financial institutions embrace cryptocurrency investments.',
        relatedLink: 'What Bitcoin at $100K Means for Crypto Market',
        articleUrl: '/article/bitcoin-100k-milestone'
      },
      secondaryStories: [
        { title: 'Major Banks Launch Cryptocurrency Trading Desks', opinion: false, articleUrl: '/article/banks-crypto-trading' },
        { title: 'Is the Crypto Boom Sustainable This Time?', opinion: true, author: 'Michael Foster', articleUrl: '/article/crypto-boom-sustainable' },
        { title: 'Ethereum Upgrade Promises Faster, Cheaper Transactions', opinion: false, articleUrl: '/article/ethereum-upgrade' }
      ]
    }
  ];

  const gridNews = [
    {
      id: 1,
      title: 'US Futures Lag Peers Ahead of Bank Earnings, CPI',
      description: 'Markets brace for key economic indicators and quarterly results from major financial institutions.',
      image: 'https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=800&h=500&fit=crop',
      category: 'Markets Wrap',
      hasVideo: false,
      articleUrl: '/article/us-futures-bank-earnings'
    },
    {
      id: 2,
      title: 'Trump Ally Jeanine Pirro Is Going After Powell, Heedless of Backlash',
      description: 'Political pressure mounts on Federal Reserve leadership as administration allies',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=500&fit=crop',
      category: 'EXCLUSIVE',
      hasVideo: false,
      articleUrl: '/article/pirro-powell-backlash'
    },
    {
      id: 3,
      title: 'Why the Renovation of the Fed HQ is Costing $2.5 Billion',
      description: 'An examination of the unprecedented costs behind the Federal Reserve headquarters',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=500&fit=crop',
      category: 'Explainer',
      hasVideo: false,
      articleUrl: '/article/fed-hq-renovation-cost'
    }
  ];

  return (
    <section className="featured-story">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        pagination={{
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className}"><span class="swiper-progress-fill"></span></span>`
        }}
        loop
        className="featured-story-swiper"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            {/* Hero Article */}
            <article className="hero-article">
              <a href={slide.heroArticle.articleUrl} className="hero-image-link">
                <div className="hero-image">
                  <img 
                    src={slide.heroArticle.image} 
                    alt={slide.heroArticle.alt} 
                    loading="eager"
                  />
                  {slide.heroArticle.hasVideo && (
                    <>
                      <div className="play-icon">
                        <svg width="60" height="60" viewBox="0 0 60 60">
                          <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.6)"/>
                          <polygon points="23,15 23,45 45,30" fill="white"/>
                        </svg>
                      </div>
                      <div className="video-duration">{slide.heroArticle.duration}</div>
                    </>
                  )}
                </div>
              </a>
              <div className="hero-content">
                <span className="category">{slide.heroArticle.category}</span>
                <h2>
                  <a href={slide.heroArticle.articleUrl}>{slide.heroArticle.title}</a>
                </h2>
                <p>{slide.heroArticle.description}</p>
                <a href={slide.heroArticle.articleUrl} className="related-link">{slide.heroArticle.relatedLink}</a>
              </div>
            </article>

            {/* Secondary Stories Grid */}
            <div className="secondary-stories">
              {slide.secondaryStories.map((story, idx) => (
                <article key={idx} className="secondary-story">
                  {story.opinion && (
                    <span className="opinion-label">Opinion | {story.author}</span>
                  )}
                  <h3><a href={story.articleUrl}>{story.title}</a></h3>
                </article>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* News Grid Section */ }
      <div className="news-grid-section">
        <div className="news-grid-container">
          {gridNews.map((news) => (
            <a key={news.id} href={news.articleUrl} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="news-grid-item">
              <div className="news-grid-image">
                <img src={news.image} alt={news.title} />
                {news.hasVideo && (
                  <>
                    <div className="news-play-icon">
                      <svg width="50" height="50" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="25" fill="rgba(0,0,0,0.6)"/>
                        <polygon points="20,15 20,35 35,25" fill="white"/>
                      </svg>
                    </div>
                    {news.duration && <div className="news-duration">{news.duration}</div>}
                  </>
                )}
              </div>
              <div className="news-grid-content">
                <span className="news-category">{news.category}</span>
                <h3>{news.title}</h3>
                <p>{news.description}</p>
              </div>
            </article>
            </a>
          ))}
        </div>
      </div>

     

      {/* Large Featured Article */}
      <a href="/article/asian-stocks-best-start" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
      <article className="large-featured">
        <div className="large-featured-image">
          <img 
            src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop" 
            alt="Stock Market Display"
          />
        </div>
        <div className="large-featured-content">
          <h2>Asian Stocks in Best-Ever Start to a Year</h2>
        </div>
      </article>
      </a>
    </section>
  );
};

export default FeaturedStory;
